import { LogOut, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { authClient } from '@/lib/auth-client';

const initials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

export function UserMenu({
  name,
  email,
  platformLink,
}: {
  name: string;
  email: string;
  /** Mobiel: Platformbeheer staat niet in de tabbalk (max. vijf tabs). */
  platformLink?: boolean;
}) {
  async function logout() {
    await authClient.signOut();
    // Volledige paginalading: de shell verdwijnt zodra de sessie weg is (een
    // client-side navigate gaat dan verloren) en zo blijft er geen data van de
    // vorige gebruiker in het geheugen.
    window.location.replace('/inloggen');
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className="grid size-11 place-items-center rounded-full outline-none focus-visible:ring-2 focus-visible:ring-ring"
        aria-label="Gebruikersmenu"
      >
        <span className="grid size-8 place-items-center rounded-full bg-muted text-xs font-semibold text-muted-foreground">
          {initials(name)}
        </span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60">
        <DropdownMenuLabel className="grid gap-0.5 font-normal">
          <span className="truncate text-sm font-medium text-foreground">{name}</span>
          <span className="truncate text-xs text-muted-foreground">{email}</span>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {platformLink && (
          <DropdownMenuItem asChild className="lg:hidden">
            <Link to="/platform">
              <ShieldCheck aria-hidden="true" />
              Platformbeheer
            </Link>
          </DropdownMenuItem>
        )}
        <DropdownMenuItem onSelect={() => void logout()}>
          <LogOut aria-hidden="true" />
          Uitloggen
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
